define('TescoMobile_Checkout/js/view/messages',['ko', 'jquery', 'Magento_Ui/js/view/messages', '../model/messageList', 'jquery-ui-modules/effect-blind'], function (ko, $, Component, globalMessages) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/messages',
      selector: '[data-role=checkout-messages]',
      isHidden: false,
      hideTimeout: 5000,
      hideSpeed: 500,
      listens: null
    },
    initialize: function (config, messageContainer) {
      this._super().initObservable();
      this.messageContainer = messageContainer || config.messageContainer || globalMessages;
      return this;
    }
  });
});

